module.exports = __webpack_public_path__ + "static/media/wait_spa.52586e67.png";